import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { itemForPath, NAV_ITEMS } from "~/components/shell/navigation";

/**
 * The phone tab bar.
 *
 * Fixed to the bottom with safe-area padding, so it sits above the iOS home indicator
 * rather than under it. The selected tab is derived from the URL rather than held in
 * state — the URL is the single source of truth, including after a deep link.
 *
 * Hidden at the desktop breakpoint, where `SideNav` takes over.
 */
export function BottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const current = itemForPath(location.pathname);

  return (
    <Paper
      elevation={0}
      sx={{
        display: { xs: "block", md: "none" },
        position: "fixed",
        insetInline: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        borderRadius: 0,
        paddingBottom: "env(safe-area-inset-bottom)",
        backdropFilter: "blur(12px)",
      }}
    >
      <BottomNavigation
        component="nav"
        aria-label={t("nav.primary")}
        value={current?.path ?? false}
        onChange={(_event, path: string) => void navigate(path)}
        showLabels
        data-testid="bottom-nav"
      >
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <BottomNavigationAction
              key={item.path}
              value={item.path}
              label={t(item.labelKey)}
              icon={<Icon />}
              data-testid={`nav.${item.path.replace("/", "")}`}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}
